import React, { useEffect } from 'react';
import './rcs2024.css';
import { rcs2024 } from '../../json/rcs2024';

const Rcs2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Seleccionados de los Programas Sociales 2024</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
             
              <div style={{ textAlign: 'left' }}>

              <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/estadisticas/Est_ByD_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Estadisticas del programa Bienestar y Desarrollo 2024</a></strong></h5>
                <p>
                </p>                

              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Rcs2024;